export function handleError(error: unknown): string {
  if (typeof error === "string") {
    return error;
  } else if (error && typeof error === "object" && "response" in error) {
    return (error as { response: { data: { message: string } } }).response.data
      .message;
  } else if (error instanceof Error) {
    return error.message;
  }
  return "An error has occurred";
}
